export type ClerkLandingState = "loading" | "dashboard" | "landing";

export function resolveClerkLandingState({
  authIsLoaded,
  authIsSignedIn,
  sessionStatus,
}: {
  authIsLoaded: boolean;
  authIsSignedIn: boolean | undefined;
  sessionStatus: string | null | undefined;
}): ClerkLandingState {
  if (!authIsLoaded || authIsSignedIn === undefined) return "loading";
  if (authIsSignedIn === false) return "landing";
  if (sessionStatus === "active") return "dashboard";
  if (sessionStatus === "pending" || sessionStatus == null) return "loading";
  return "landing";
}